/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import {DashGisUtil} from './dash-gis-util';

export class DashGisImmutable {

    static push(arr: any[], val: any) {
        return [
            ...arr,
            val,
        ];
    }

    static pop(arr: any[]): [any[], any] {
        const popped = DashGisUtil.clone(arr[arr.length - 1]);
        const newArray = arr.slice(0, -1);
        return [newArray, popped];
    }
}
